import React from 'react' 
import floppy_disk from '../../assets/icons/floppy_disk.png'

export const FloppyDisk = ({...props}) => {
    return <img src={floppy_disk} alt='Floppy Disk' {...props} />
}